import { USAGE_TEXTS as TEXTS } from "./texts.ts";
import { describeCost, type UsageTotals } from "./usage.ts";

/**
 * El desglose de un consumo: las cuatro clases de token y lo que cuestan.
 *
 * Lo comparten el tooltip del contador de arriba, el de la conversación y el
 * del pie de cada turno, para que "caché" signifique lo mismo en los tres.
 *
 * Aquí los números van ENTEROS y no abreviados: quien abre el desglose es
 * quien quiere el número, no la idea.
 */
export function UsageBreakdown({
  usage,
  title,
}: {
  usage: UsageTotals;
  title?: string;
}) {
  const cost = describeCost(usage.costUsd, usage.unpricedCalls);
  const rows: [string, number][] = [
    [TEXTS.breakdown.input, usage.input],
    [TEXTS.breakdown.cachedInput, usage.cachedInput],
    [TEXTS.breakdown.cacheWriteInput, usage.cacheWriteInput],
    [TEXTS.breakdown.output, usage.output],
  ];

  return (
    <div className="grid gap-1">
      {title !== undefined && <p className="font-medium">{title}</p>}
      <dl className="grid grid-cols-[1fr_auto] gap-x-4 tabular-nums">
        {rows.map(([label, value]) => (
          <div key={label} className="contents">
            <dt className="text-muted-foreground">{label}</dt>
            <dd className="text-right">{value.toLocaleString("es")}</dd>
          </div>
        ))}
      </dl>
      <p className={cost.kind === "estimated" ? undefined : "text-warning"}>
        {TEXTS.breakdown.cost(cost.long)}
      </p>
    </div>
  );
}
